// material-ui
import { Grid } from '@material-ui/core';
import React from 'react';

// api
import { getNetwork, INetwork, transformNetworkWrapper } from '~/src/dash/api/network';
import { IHttpResponse } from '~/src/dash/api/rest';
// other
import { IStore } from '~/src/dash/reducers/store';
import {
  extractRouteParams,
  navigate,
  parseLocation,
  RouteNetworkList,
} from '~/src/dash/router/routes';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
// utils
import { decorate } from '~/src/dash/utils/decorator';
// views
import { LoadingView } from '~/src/dash/views/loading-view';
import { NetworkSettingsView } from '~/src/dash/views/networks/network-settings-view';
import { SnackbarView } from '~/src/dash/views/snackbar-view';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {}

interface IState {
  currentNetwork?: INetwork;
  // error messaging
  snackbarMessage: string;
  snackbarError: boolean;
  // ok to render the network settings view
  loaded: boolean;
}

export const NetworkSettingsExistingView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = {
      currentNetwork: undefined,
      snackbarMessage: '',
      snackbarError: false,
      loaded: false,
    };

    componentDidMount() {
      this.getNetwork();
    }

    getNetwork(): void {
      // get network id from the url and make API call
      const loc = parseLocation(this.props.location.pathname);
      if (loc.network) {
        getNetwork(loc.network, this.props.session.publisher.ID)
          .then((val: IHttpResponse<INetwork>) => {
            const currentNetwork = transformNetworkWrapper(val.parsedBody);
            this.setState({
              currentNetwork,
              loaded: true,
            });
          })
          .catch(() => {
            this.setState(
              {
                snackbarMessage:
                  "You don't have access to this resource. Please create a new one or select one from the list.",
                snackbarError: true,
              },
              () => {
                setTimeout(() => {
                  navigate(
                    RouteNetworkList,
                    extractRouteParams({
                      session: this.props.session,
                      user: this.props.user,
                    }),
                  );
                }, 3000);
              },
            );
          });
      }
    }

    handleCloseSnackbar = (): void => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
      });
    };

    render() {
      const { loaded, currentNetwork, snackbarMessage, snackbarError } = this.state;
      if (loaded) {
        return (
          <Grid>
            <NetworkSettingsView isClone={false} currentNetwork={currentNetwork} />
            <SnackbarView
              open={!!snackbarMessage}
              error={!!snackbarError}
              onClose={this.handleCloseSnackbar}
            >
              {snackbarMessage}
            </SnackbarView>
          </Grid>
        );
      } else {
        return <LoadingView active={true} text='Loading the network settings' />;
      }
    }
  },
);
